export default __webpack_public_path__ + "static/media/flor.62b51f5d.svg";